import client from './client';

export default {
  respondSend(params) {
    return client.post('/payments/subscriptions/subscribe')
      .send(params)
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/premiumSubscriptionAPI.js